<script>
export default {
    props: ['banner', 'title', 'desc'],
    name: "banner",
    data() {
        return {};
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="banner">
        <div class="banner_bg" :style="`background-image: url(${banner});`"></div>
        <div class="wrapper">
            <div class="title">{{ title }}</div>
            <div class="desc">{{ desc }}</div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.banner{
    position: relative;
    .banner_bg{
        width: 100%;
        height: 6rem;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        @media only screen and (max-width: 750px) {
            height: 8rem;
        }
    }
    .wrapper{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-shadow: 0 0 .1rem rgba($color: #000, $alpha: .5);
        @media only screen and (max-width: 750px) {
            padding-top: 2.4rem;
        }
        .title{
            font-size: .48rem;
            line-height: 1.1;
            margin-bottom: .4rem;
            @media only screen and (max-width: 750px) {
                font-size: .68rem;
            }
        }
        .desc{
            font-size: .2rem;
            line-height: 1.8;
            max-width: 9rem;
            text-align: center;
            @media only screen and (max-width: 750px) {
                font-size: .28rem;
                max-width: 6.2rem;
            }
        }
    }
}
</style>